import {Pipe, PipeTransform} from '@angular/core';
import {IBookingSearchResultConfig} from "libraries/interfaces/IConfigurableTable";

@Pipe({
    name: 'computeColumnIndex',
})

export class ComputeColumnIndexPipe implements PipeTransform {
    public transform(index: number, config: IBookingSearchResultConfig): number {
        if (config.canSelectItems) {
            return index - 1;
        }
        return index;
    }
}
